import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cosa-facciamo',
  templateUrl: './cosa-facciamo.component.html',
  styleUrls: ['./cosa-facciamo.component.scss']
})
export class CosaFacciamoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/cosa-facciamo/cosa-facciamo.component.ts